/**
 * documentへカスタムイベントを送信
 */
export class EventDispatcher {
	static dispatch(eventName) {
		document.dispatchEvent(new CustomEvent(eventName));
	}
}
